export default "<ngx-monaco-editor class=\"vl-code-editor\" [options]=\"editorOptions\" [(ngModel)]=\"decodedContent\"></ngx-monaco-editor>\n";